import React, { useId } from "react";

/** Details panel split / sidebar toggle (24×24). */
export function IconDetailsSplit24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M10 21L10 3" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13 3L16 3C18.7614 3 21 5.23858 21 8L21 16C21 18.7614 18.7614 21 16 21L13 21"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3L8 3C5.23858 3 3 5.23858 3 8L3 16C3 18.7614 5.23858 21 8 21L10 21"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Chat bubble with spark (24×24) — left nav + details history rows. */
export function IconChat24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M14 4H6C4.343 4 3 5.343 3 7V15C3 16.657 4.343 18 6 18H7.5V21L12 18H18C19.657 18 21 16.657 21 15V10"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.414 6.41399C19.633 7.19499 18.367 7.19499 17.586 6.41399C16.805 5.63299 16.805 4.36699 17.586 3.58599C18.367 2.80499 19.633 2.80499 20.414 3.58599C21.195 4.36699 21.195 5.63399 20.414 6.41399"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconPlus16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M8 3.333V12.667" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3.333 8H12.667" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

/** Visited page / document search (16×16). */
export function IconPageVisit16(props) {
  const paintId = useId().replace(/:/g, "");
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6666 5.33333H9.99992C9.63192 5.33333 9.33325 5.03467 9.33325 4.66667V2"
        fill={`url(#${paintId})`}
        fillOpacity="0.5"
      />
      <path
        d="M12.6666 5.33333H9.99992C9.63192 5.33333 9.33325 5.03467 9.33325 4.66667V2"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33325 8.66667V3.33333C3.33325 2.59667 3.92992 2 4.66659 2H9.44792C9.80125 2 10.1406 2.14067 10.3906 2.39067L12.2759 4.276C12.5259 4.526 12.6666 4.86533 12.6666 5.21867V12.6667C12.6666 13.4033 12.0699 14 11.3333 14H8.66658"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83122 12.9259C6.16122 13.5959 5.07655 13.5959 4.40655 12.9259C3.73655 12.2559 3.73655 11.1713 4.40655 10.5013C5.07655 9.83128 6.16122 9.83128 6.83122 10.5013C7.50055 11.1713 7.50055 12.2573 6.83122 12.9259"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 7.33333H10" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.66675 9.33333H10.0001" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.33325 14L4.40659 12.926" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={paintId} x1="10.9999" y1="2" x2="10.9999" y2="5.33333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#D5DCE1" />
          <stop offset="1" stopColor="#D5DCE1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/** Chat history message bubble (16×16). */
export function IconHistory16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M6 14L9.33333 11.3193" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.00008 11.3333V13.9999" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6 11.3333H5.33333C3.49267 11.3333 2 9.84067 2 8V5.33333C2 3.49267 3.49267 2 5.33333 2H10.6667C12.5073 2 14 3.49267 14 5.33333V8C14 9.84067 12.5073 11.3333 10.6667 11.3333H9.33333"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
